import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { Link } from '@ynap/router';

const bem = new BEMHelper('ProductInformation');

const designer = (designerName, isLoading, listingURL = '', baseUrl = '', designerModifier = '', accordionContentRef, soldOut) => (
    <h1 ref={accordionContentRef} className={bem('designer', [isLoading, designerModifier, soldOut ? 'soldOut' : ''])}>
        <span dir="ltr">{designerName}</span>
    </h1>
);

const ProductInformation = (props) => {
    const {
        name,
        designerName,
        designerSeo,
        productId,
        skuId,
        className,
        generateListingUrl,
        plpUrlTemplate,
        locale,
        loading,
        baseUrl,
        designerLinkOnClick = () => {},
        promoPriceApplied,
        setWidth,
    } = props;
    const isLoading = loading ? 'loading' : null;

    const { container = '', designerModifier = null, nameModifier = null, selectedProductBadgeModifier = null, soldOut = null } = className;
    const accordionContentRef = useRef(null);

    useEffect(() => {
        const carouselWidthCalculation = accordionContentRef?.current?.offsetWidth;
        carouselWidthCalculation && setWidth?.(carouselWidthCalculation);
    }, [accordionContentRef]);

    return (
        <div className={bem(null, null, container)}>
            {designerSeo ? (
                <Link
                    to={generateListingUrl(plpUrlTemplate, {
                        LOCALE: locale,
                        SEO_URLKEYWORD: designerSeo.seoURLKeyword,
                    })}
                    onClick={designerLinkOnClick}
                >
                    {designer(
                        designerName,
                        isLoading,
                        generateListingUrl(plpUrlTemplate, {
                            LOCALE: locale,
                            SEO_URLKEYWORD: designerSeo.seoURLKeyword,
                        }),
                        baseUrl,
                        designerModifier,
                        accordionContentRef,
                        soldOut,
                    )}
                </Link>
            ) : (
                designer(designerName, loading, null, null, designerModifier, null, soldOut)
            )}

            {/* product/sku info for personal shopper chrome extension */}
            <meta itemProp="productID" content={productId} />
            <meta itemProp="sku" content={skuId} />
            {name && (
                <p className={bem('name', [isLoading, nameModifier, promoPriceApplied, selectedProductBadgeModifier, soldOut ? 'soldOut' : ''])}>{name}</p>
            )}
        </div>
    );
};

ProductInformation.propTypes = {
    loading: PropTypes.bool,
    productId: PropTypes.string.isRequired,
    skuId: PropTypes.string,
    name: PropTypes.string.isRequired,
    designerName: PropTypes.string.isRequired,
    designerSeo: PropTypes.string,
    className: PropTypes.object,
    generateListingUrl: PropTypes.func,
    plpUrlTemplate: PropTypes.string,
    locale: PropTypes.string,
    baseUrl: PropTypes.string,
    designerLinkOnClick: PropTypes.func,
    promoPriceApplied: PropTypes.string,
    selectedProductBadgeModifier: PropTypes.string,
};

ProductInformation.defaultProps = {
    className: {},
};

export default ProductInformation;
